//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import angular, { IHttpInterceptor, IQService, IRequestConfig } from 'angular';

import { CuralateAuthTokenHeader } from '@constants/CuralateAuthTokenHeader';

import { getRequiredJwtToken } from 'app/initialization/amplify/auth';

function isLwsApiUrl(url: string) {
  return url.startsWith('/api/');
}

class CognitoTokenInterceptor implements IHttpInterceptor {
  constructor(private readonly $q: IQService) {}

  // HTTP request interceptor: Called when a request is made (pre-request)
  public request = (config: IRequestConfig) => {
    // Don't add jwt to every request, only local ones
    if (!isLwsApiUrl(config.url)) {
      return config;
    }
    return this.$q.when(
      getRequiredJwtToken()
        .then((jwt) => {
          config.headers = {
            ...config.headers,
            [CuralateAuthTokenHeader]: jwt,
          };
          return config;
        })
        .catch(() => this.$q.reject('No valid session')),
    );
  };

  // HTTP response error interceptor: redirect to login on 401 from LWS
  public responseError = (rejection: {
    config: IRequestConfig;
    status: number;
  }) => {
    if (
      rejection.status === 401 &&
      isLwsApiUrl(rejection.config.url) &&
      window.location.pathname !== '/login'
    ) {
      window.location.href = '/login';
    }
    return this.$q.reject(rejection);
  };
}

angular
  .module('curalate')
  .service('cognitoTokenInterceptor', ['$q', CognitoTokenInterceptor]);
